import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { ATTACH_ACCEPT, filesFromList } from "@/lib/attach";
import { friendlyError } from "@/lib/errors";
import { toast } from "sonner";

export default function useThreadAttach({ threadId, onAttached } = {}) {
  const [items, setItems] = useState([]);
  const inputRef = useRef(null);
  const attaching = items.some((i) => i.status === "uploading" || i.status === "reading");

  const attachFiles = async (list) => {
    const files = filesFromList(list);
    if (!threadId || !files.length) return;
    for (const file of files) {
      const id = `att-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
      setItems((prev) => [...prev, { id, name: file.name, status: "uploading" }]);
      try {
        setItems((prev) => prev.map((x) => (x.id === id ? { ...x, status: "reading" } : x)));
        const form = new FormData();
        form.append("file", file);
        const { data } = await api.post(`/threads/${threadId}/attach`, form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        setItems((prev) => prev.map((x) => (x.id === id ? { ...x, status: "done" } : x)));
        onAttached?.(data);
      } catch (err) {
        setItems((prev) => prev.map((x) => (x.id === id ? { ...x, status: "error" } : x)));
        toast.error(friendlyError(err));
      }
    }
  };

  const openPicker = () => inputRef.current?.click();

  const onInputChange = (e) => {
    attachFiles(e.target.files);
    e.target.value = "";
  };

  return {
    items,
    attaching,
    attachFiles,
    openPicker,
    inputRef,
    onInputChange,
    accept: ATTACH_ACCEPT,
  };
}
